module.exports = __webpack_public_path__ + "static/about1-84ea7099f81b77d6c9c0bc327da38b00.jpg";